<template>
  <div style="width: 100%; height: 100%; border: 10px solid #edeff2">
    <a-spin :spinning="spin">
      <div class="top">
        <!-- 第一部分 -->
        <div class="classTitle">
          <div class="topTitle title">外链分类：</div>
          <div style="display: inline-block" class="content">
            <a-radio-group
              size="small"
              default-value="0"
              button-style="solid"
              @change="onChange"
            >
              <a-radio-button value="0"> 全部 </a-radio-button>
              <a-radio-button value="-1"> 默认分类 </a-radio-button>
              <a-radio-button
                :value="item.id"
                v-for="item in topData"
                :key="item.id"
              >
                {{ item.title }}
              </a-radio-button>
            </a-radio-group>
            <!-- <admin_con @click="loadList" class="iconSheZhi" type="icon-shezhi"/> -->
          </div>
          <a-button
              size="small"
              @click="showModal"
              style="border: none;box-shadow: none;color:#1890ff">
              管理
            </a-button>
        </div>

        <!-- 第二部分 -->
        <div class="selectTop">
          <div style="display: flex">
            <span class="topTitle">素材名称：</span>
            <a-input
              v-model="linkName"
              placeholder="请输入"
              style="width: 200px; margin-left: 5px"
            />
          </div>
          <div>
            <span class="topTitle">创建时间：</span>
            <a-range-picker @change="timeChange" v-model="year" />
          </div>
          <div>
            <a-button
              type="primary"
              style="margin-left: 10px; font-size: 14px"
              @click="search"
              >查询</a-button
            >
            <a-button @click="clear" style="margin-left: 20px">重置</a-button>
          </div>
        </div>
      </div>

      <div style="width: 100%; height: 10px; background: #edeff2"></div>

      <!-- 表格 -->
      <div class="bottom">
        <div style="border: 1px solid #edeff2; margin-bottom: 15px">
          <div class="moTitle">
            <div class="topTitle font">外链素材列表</div>
            <div style="margin-top: 9px">
              <a class="file" href="javascript:;" @click="addLink">+添加 </a>
            </div>
          </div>
        </div>
        <a-table
          :style="{
            width: variables.space_div,
            margin: 'auto',
            marginBottom: variables.LineSpacing,
          }"
          :columns="columns"
          :rowKey="
            (record, index) => {
              return record.id;
            }
          "
          :data-source="link"
          :pagination="false"
        >
          <!-- 图片 -->
          <template slot="is_Img" slot-scope="text, record, index">
            <!-- handleChange最后一个参数，是要修改的对象的key -->

            <div
              @click="materialLibrary(record.id, 'imageUrl')"
              class="bgImg"
              style="position: relative"
              v-if="record.editable"
            >
              <div style="position: absolute; width: 100%; text-align: center">
                <div
                  style="font-size: 17px; color: #929292; padding: 10px 20px"
                  v-if="record.imgedit"
                >
                  <span v-if="text === ''"> +上传 </span>
                </div>
              </div>
<!--              <input-->
<!--                :id="'materialLibrary' + record.id"-->
<!--                :ref="'materialLibrary' + record.id"-->
<!--                style="-->
<!--                  width: 100%;-->
<!--                  height: 100%;-->
<!--                  z-index: 999999;-->
<!--                  opacity: 1;-->
<!--                  position: absolute;-->
<!--                  top: 0;-->
<!--                  left: 0;-->
<!--                "-->
<!--                accept="image/*"-->
<!--                type="file"-->
<!--                @change="materialLibrary(record.id, 'imageUrl')"-->
<!--              />-->

              <div>
                <img
                  v-if="text != ''"
                  alt=""
                  :src="text"
                  style="width: 100%; height: 45px"
                />
              </div>
            </div>

            <!--
          <a-input v-if="record.editable" style="margin: -5px 0" :value="text"
            @change="e => handleChange(e.target.value, record.id, 'imageUrl')" /> -->
            <template v-else>
              <img style="width: 100%; height: 50px" :src="text" />
            </template>
          </template>
          <!-- 名称 -->
          <template slot="linNo" slot-scope="text, record, index">
            <a-input
              v-if="record.editable"
              style="margin: -5px 0"
              :value="text"
              @change="(e) => handleChange(e.target.value, record.id, 'name')"
            />

            <template v-else>
              <diV
                style="
                  width: 100%;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
              >
                {{ text }}
              </diV>
            </template>
          </template>
          <!-- 链接 -->
          <template slot="is_link" slot-scope="text, record, index">
            <a-input
              v-if="record.editable"
              style="margin: -5px 0"
              :value="text"
              @change="(e) => handleChange(e.target.value, record.id, 'link')"
            />
            <template v-else>
              <diV
                style="
                  width: 100%;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
              >
                <a :href="text" target="_blank">{{ text }}</a>
              </diV>
            </template>
          </template>
          <!-- 分类 -->
          <template slot="is_type" slot-scope="text, record, index">
            <div v-if="record.editable" style="width: 97%; display: flex">
              <a-select
                :placeholder="record.columnName"
                @change="(e) => handleSelectChange(e, record.id)"
                style="width: 120px"
              >
                <a-select-option
                  v-for="(item, index) in topData"
                  :key="item.id"
                  :value="`${item.id}&&${item.title}`"
                >
                  {{ item.title }}
                </a-select-option>
              </a-select>
              <a-icon
                type="reload"
                @click="clearAdd"
                style="
                  font-size: 17px;
                  color: #1890ff;
                  line-height: 35px;
                  margin-left: 10px;
                "
              />
              <a-icon
                type="plus-square"
                @click="addAgain"
                style="
                  font-size: 17px;
                  color: #1890ff;
                  line-height: 35px;
                  margin-left: 10px;
                "
              />
            </div>
            <span v-else>
              {{ record.columnName }}
            </span>
            <!-- <a-input v-if="record.editable" style="margin: -5px 0" :value="text"
            @change="e => handleChange(e.target.value, record.id, 'columnId')" />
          <template v-else>
            {{ text }}
          </template> -->
          </template>

          <template slot="operation" slot-scope="text, record, index">
            <div class="editable-row-operations">
              <span v-if="record.editable">
                <a
                  @click="() => save(record, record.id)"
                  style="margin-right: 5px; font-weight: 550"
                  >保存</a
                >
                &ensp;
                <a-popconfirm
                  title="确认取消?"
                  @confirm="() => cancel(record.id)"
                >
                  <a style="margin-right: 5px; font-weight: 550">取消</a>
                </a-popconfirm>
              </span>
              <span v-else>
                <a
                  @click="() => edit(record.id, record)"
                  style="margin-right: 5px; font-weight: 550"
                  >编辑</a
                >
                <a
                  style="margin-right: 5px; font-weight: 550"
                  @click="moveLink(record)"
                >
                  移动分类
                </a>
                <a-popconfirm
                  title="确定删除?"
                  ok-text="是"
                  cancel-text="否"
                  @confirm="del(record)"
                  @cancel="cancel1"
                >
                  <a style="font-weight: 550">删除</a>
                </a-popconfirm>
              </span>
            </div>
          </template>
        </a-table>
      </div>

      <!-- 移动分组弹窗 -->
      <a-modal
        :visible="visible"
        title="选择分类"
        @ok="handleOk"
        @cancel="handleCancel"
        style="position: fixed; z-index: 999999"
        width="30%"
      >
        <a-radio-group
          button-style="solid"
          :default-value="categoryId"
          :key="categoryId"
          style="padding: 10px 10px 30px 10px"
        >
          <a-radio-button :value="-1" :key="-1" @click="handle(-1)"
            >默认分类</a-radio-button
          >
          <a-radio-button
            :value="item.id"
            v-for="item in topData"
            :key="item.id"
            @click="handle(item.id)"
          >
            {{ item.title }}
          </a-radio-button>
        </a-radio-group>
        <!-- <a-button
        @click="handle(item)"
        v-for="item in topData"
        :key="item.id"
        style="margin-left: 20px"
        >{{ item.title }}</a-button
      > -->

        <!-- <a-radio-button
        :value="item.id"
        v-for="item in topData"
        :key="item.id"
        @click="handle(item)"
        style="border: 1px silid"
      >
        {{ item.title }}
      </a-radio-button> -->
      </a-modal>
      <!-- 分页 -->
      <div style="display: flex; justify-content: center; margin-bottom: 15px">
        <a-pagination
          :current="curPage"
          :total="total"
          :pageSize="pageSize"
          show-quick-jumper
          @change="PageNOchange"
          style="display: inline-block"
        />
      </div>

      <!-- -----------------新增对话框 ----------------------------------->
      <a-modal title="新增" :visible="visible3" @ok="addOk" @cancel="addCancel">
        <a-form-model
          :model="form"
          :rules="addRules"
          ref="ruleForm_add"
          style="display: flex"
        >
          <a-form-model-item label="分类标题" prop="name" style="display: flex">
            <a-input
              placeholder="请输入"
              v-model="form.name"
              style="display: flex; margin-top: 5px; width: 220px"
            />
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </a-spin>
    <!-- 新增对话框 -->
    <a-modal
      title="新增分类"
      :visible="visibleClass"
      @ok="handleOkClass"
      @cancel="handleCancelClass"
      style="width: 200px; height: 130px"
    >
      <a-form-model
        :model="formClass"
        :rules="addRulesClass"
        ref="ruleForm_add"
        style="display: flex"
      >
        <a-form-model-item label="分类标题" prop="name" style="display: flex">
          <a-input
            placeholder="请输入"
            v-model="formClass.name"
            style="display: flex; margin-top: 5px; width: 220px"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 管理弹窗 -->
    <a-modal v-model="modalShow" title="外链分类管理" @ok="handleSubmit" @cancel="modalCancel" width="1000px">
        <!-- <a-spin :spinning="spin"> -->
          <!-- 头部 -->
          <div class="top2">
            <span :style="{ color: variables.topTitleColor }">分类名称：</span>
            <a-input
              placeholder="请输入"
              style="width: 200px; margin-left: 5px"
              v-model="remark"
            />
            <a-button
              type="primary"
              style="margin-left: 10px; font-size: 14px"
              @click="searchManange"
              >查询</a-button
            >
            <a-button @click="Manageclear" style="margin-left: 20px">重置</a-button>
          </div>
          <!-- 中间 -->
          <!-- <div style="width: 100%; height: 2px; background: #edeff2"></div> -->
          <!-- 列表 -->
          <!-- <div class="liebiao">
            <div class="title">分类列表</div>
          </div> -->
          <div
            :style="{
              width: variables.space_div,
              margin: 'auto',
              paddingTop: variables.LineSpacing,
              paddingBottom: variables.LineSpacing,
            }"
          >
            <a-button type="primary" @click="add1Management">新增</a-button>
          </div>
          <div :style="{ width: variables.space_div, margin: 'auto' }">
            <a-table
              :pagination="false"
              :row-key="(record) => record.id"
              :columns="columnsAdd"
              :dataSource="dataSource"
            >
              <!-- 操作 -->
              <span slot="is_operation" slot-scope="text, record, index">
                <a
                  style="margin-right: 10px; "
                  @click="upMove(record)"
                  v-show="index === 0 ? false : true"
                  >上移</a
                >
                <a
                  style="margin-right: 10px; "
                  @click="downMove(record)"
                  v-show="index === dataSource.length - 1 ? false : true"
                  >下移</a
                >
                <a
                  style="margin-right: 10px; "
                  @click="manageEdit(record)"
                  >编辑</a
                >
                <a-popconfirm
                  title="确定删除?"
                  ok-text="是"
                  cancel-text="否"
                  @confirm="delManage(record)"
                >
                  <a >删除</a>
                </a-popconfirm>
              </span>
            </a-table>
            <div
              style="
                width:100%;
                margin-top: 28px;
                display: flex;
                align-items: center;
                justify-content: space-between;"
            >
            <span></span>
            <span>
              <a-pagination
                v-model="pageNoManage"
                :total="managetotal"
                show-less-items
                @change="handlepageNo"
              />
            </span>
            </div>
          </div>


          <!-- -----------------新增对话框 ----------------------------------->
          <a-modal
            title="新增"
            :visible="newBuildvisible"
            @ok="handleNewOk"
            @cancel="handleNewCancel"
          >
            <a-form-model
              :model="newBuildform"
              :rules="addNewRules"
              ref="ruleNewForm_add"
              style="display: flex"
            >
              <a-form-model-item label="分类标题" prop="name" style="display: flex">
                <a-input
                  placeholder="请输入"
                  v-model="newBuildform.name"
                  style="display: flex; margin-top: 5px; width: 220px"
                />
              </a-form-model-item>
            </a-form-model>
          </a-modal>

      <!---------------------- 编辑对话框------------------- -->
      <a-modal
        title="编辑"
        :visible="visible2"
        @ok="editOk"
        @cancel="editCancel"
      >
        <a-form-model
          :model="newBuildform"
          :rules="addNewRules"
          ref="ruleForm_edit"
          style="display: flex"
        >
          <a-form-model-item label="分类标题" prop="name" style="display: flex">
            <a-input
              placeholder="请输入"
              style="display: flex; margin-top: 5px; width: 220px"
              v-model="newBuildform.name"
            />
          </a-form-model-item>
        </a-form-model>
      </a-modal>

        <!-- </a-spin> -->
      </a-modal>

    <MessageAlert
      :visible="visibleAlert"
      v-on:closeMain="closeMainAlert"
    ></MessageAlert>
    <pictureDialog
        :info="pInfo"
        :visible="visiblePic"
        v-on:closeMain="closeMain"
        v-on:checkList="checkList"
    >
    </pictureDialog>
  </div>
</template>

<script>
import {
    updatedManagement,
  moveManagement,
} from "../../../service/columnmanageapi";
import {getAuthenticationInformation} from "@/service/authentication";
import variables from "@/assets/base.scss";
import { AddManagement } from "../../../service/columnmanageapi";
import {
  getManagement,
  getLink,
  changeLink,
  delLink,
  InsertLink,
} from "../../../service/columnmanageapi";
import { update, update_File } from "@/utils/update";
import { admin_icon } from "@/utils/myIcon";
import MessageAlert from "@/components/Authentication/MessageAlert";
import pictureDialog from "@/components/Material/pictureDialog";
export default {
  name: "pictureControl",
  components: { admin_con: admin_icon,MessageAlert,pictureDialog },
  data() {
    return {
      // 管理 弹窗
      visible2:false,
      spin:false,
      remark: "",
      pageNoManage: 1,
      newBuildvisible:false,
      newBuildform: {
        name: "",
        code: "1",
      },
      addNewRules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          {
            validator: function (rule, value, callback) {
              if (/^[^\s]+[\s]*.*$/i.test(value) == false) {
                callback(new Error("请输入正确的名称"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      pageSizeManage: 10,
      dataSource: [],
      managetotal: 0,
      modalShow:false,
      addform: {},
      columnsAdd: [
        {
          title: "序号",
          // width: "17%",
          key: "num",

          customRender: (text, record, index) =>
            `${(this.pageNoManage - 1) * this.pageSizeManage + (index + 1)}`,
        },

        {
          title: "名称",
          dataIndex: "title",
          // width: "24%",
          key: "title",
        },

        {
          title: "创建人",
          dataIndex: "createdByName",
          // width: "20%",
          key: "createdByName",
        },
        {
          title: "创建时间",
          dataIndex: "createdTime",
          // width: "23%",
          key: "createdTime",
        },
        {
          title: "操作",
          dataIndex: "operation",
          // width: "25%",
          scopedSlots: { customRender: "is_operation" },
          key: "operation",
        },
      ],






      picList:[],
      pInfo:true,
      visibleAlert:false,
      visiblePic: false,
      picId:null,
      picColumn:null,
      spin: false,
      visibleClass: false,
      formClass: {},
      addRulesClass: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      variables,
      topData: [],
      link: [],
      linkName: "",
      typeId: "",
      startTime: "",
      endTime: "",
      curPage: 1,
      pageSize: 10,
      total: 0,
      visible: false,
      category: {},
      editingKey: -1,
      addId: "",
      addForm: {},
      editForm: {},
      add: [],
      year: [],
      newAdd: [],
      categoryId: "",
      visible1: true,
      visible3: false,
      form: {
        name: "",
        code: "1",
      },

      addform: {},
      // 表格数据缓存
      cacheData: [],
      // 添加的测试
      addtableCount: 0,
      userInfoList:{},
      columns: [
        {
          title: "图片",
          dataIndex: "imageUrl",
          width: "17%",
          key: "imageUrl",
          align: "center",
          scopedSlots: { customRender: "is_Img" },
        },
        {
          title: "名称",
          dataIndex: "name",
          width: "10%",
          key: "name",
          align: "center",
          scopedSlots: { customRender: "linNo" },
        },
        {
          title: "链接",
          dataIndex: "link",
          width: "20%",
          key: "link",
          align: "center",
          scopedSlots: { customRender: "is_link" },
        },
        {
          title: "创建时间",
          dataIndex: "createdTime",
          width: "15%",
          key: "createdTime",
          align: "center",
        },
        {
          title: "分类",
          dataIndex: "columnName",
          width: "15%",
          key: "columnName",
          ellipsis: true,
          align: "center",
          scopedSlots: { customRender: "is_type" },
        },
        {
          title: "操作",
          dataIndex: "operation",
          width: "20%",
          scopedSlots: { customRender: "operation" },
          key: "operation",
          align: "center",
        },
      ],
      addRules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          {
            validator: function (rule, value, callback) {
              if (/^[^\s]+[\s]*.*$/i.test(value) == false) {
                callback(new Error("请输入正确的名称"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.load();
    this.getType();
    this.getInformation()
  },
  methods: {
        // 删除
        delManage(record) {
      updatedManagement({
        id: record.id,
        title: record.title,
        code: record.code,
        delStatus: 1,
        type: "link",
      }).then((res) => {
        if (res.code == 200) {
          this.Manageload();
          this.getType();
          this.$message.success("删除成功");
        } else {
          this.$message.warning("删除失败");
        }
      });
    },
    // 编辑确定
    editOk() {
      this.$refs.ruleForm_edit.validate(async (valid) => {
        if (valid) {
          updatedManagement({
            id: this.addform.id,
            title: this.newBuildform.name,
            code: this.addform.code,
            delStatus: 0,
            type: "link",
          }).then((res) => {
            if (res.code == 200) {
              this.$message.success("编辑成功");
              this.visible2 = false;
              this.Manageload();
              this.getType();
              this.$refs.ruleForm_edit.resetFields();
              this.newBuildform.name = "";
            } else {
              this.$message.warning("编辑失败");
            }
          });
        }
      });
    },
    // 编辑取消
    editCancel() {
      this.visible2 = false;
      this.newBuildform.name = "";
      this.newBuildform.code = "";
      this.Manageload();
      this.$refs.ruleForm_edit.resetFields();
      // this.spin = false;
    },
    // 打开编辑
    manageEdit(record) {
      this.newBuildform.name = record.title;
      this.addform = record;
      this.visible2 = true;
    },
    //上移
    upMove(record) {
      moveManagement("up", record.id, "link").then((res) => {
        if (res.code == 0) {
          this.Manageload();
          this.getType();
          this.$message.success("上移成功");
        } else {
          this.$message.warning("上移失败");
        }
      });
    },
    // 下移
    downMove(record) {
      moveManagement("down", record.id, "link").then((res) => {
        if (res.code == 0) {
          this.Manageload();
          this.getType();
          this.$message.success("下移成功");
        } else {
          this.$message.warning("下移失败");
        }
      });
    },
    handlepageNo(pageNo, pageSize) {
      this.Manageload();
    },
    handleNewCancel(){
      this.newBuildvisible = false;
    },
    // 新增确定
    handleNewOk() {
      // this.spin = true;
      this.$refs.ruleNewForm_add.validate(async (valid) => {
        if (valid) {
          let form = {
            title: this.newBuildform.name,
            type: "link",
          };
          AddManagement(form).then((res) => {
            if (res.code == 200) {
              // this.spin = false;
              this.Manageload();
              this.getType();
              this.$message.success("新增成功");
              this.newBuildvisible = false;
              this.newBuildform.name = "";
              this.$refs.ruleNewForm_add.resetFields();
            } else {
              this.$message.warning("新增失败");
              this.Manageload();
              this.$refs.ruleNewForm_add.resetFields();
            }
          });
        }
      });
    },
    // 打开新增
    add1Management() {
      if (!this.userInfoList.id) {
        this.visibleAlert = true;
      } else {
        this.newBuildvisible = true;
        this.newBuildform.name = "";
      }
    },
    searchManange() {
      this.pageNoManage = 1;
      this.Manageload();
    },
    // 获取全部数据类型
    Manageload() {
      // this.spin = true;
      getManagement({
        type: "link",
        title: this.remark,
        pageNo: this.pageNoManage,
        pageSize: this.pageSizeManage,
      }).then((res) => {
        this.dataSource = res.data;
        this.managetotal = res.count;
        // this.spin = false;
      });
    },

    Manageclear() {
      (this.remark = "",this.pageNoManage = 1), this.Manageload();
    },
    showModal(){
      this.modalShow = true
      this.pageNoManage = 1
      this.remark = ''
      this.Manageload()
    },
    handleSubmit(){
      this.modalShow = false
    },
    modalCancel(){
      this.modalShow = false
    },






    checkList(val) {
      this.picList = val[0].url;
      let id = this.picId;
      let column = this.picColumn;

      //  修改表格中的imgurl,张灯珍
      const newData = [...this.link];
      const target = newData.find((item) => id === item.id);
      if (target) {
        target[column] = this.picList;
        //标志图片可编辑，上传时，改为false
        target.imgedit = false;
        // console.log(target[column]);
        this.link = newData;
      }
    },
    closeMain(val) {
      this.visiblePic = val;
    },
       async getInformation() {
      const response = await getAuthenticationInformation();
      if (response.code === 200) {
        this.userInfoList = response.data;
      } else {
        this.$message.warning('name',response.message);
      }
    },
    // 头部导航分类
    load() {
      this.spin = true;
      // getManagement({
      //   type: "link",
      // }).then((res) => {
      //   console.log(res);
      //   this.topData = res.data;
      // });
      //  获取外链
      getLink({
        name: this.linkName,
        columnId: this.typeId,
        startTime: this.startTime,
        endTime: this.endTime,
        curPage: this.curPage,
        pageSize: this.pageSize,
      }).then((res) => {
        this.spin = false;
        // 如果原本有数据，则取出editable=true的数据
        if (this.link.filter((item) => item.editable === true).length > 0) {
          const editableData = this.link.filter(
            (item) => item.editable === true
          );
          const newData = [...editableData];
          this.link = [...newData, ...res.data];
          // 表格数据，备份
          this.cacheData = [...newData, ...res.data]; // res.data.map(item => ({ ...item }));
          this.total = res.count;
        } else {
          this.link = res.data;
          // 表格数据，备份
          this.cacheData = res.data.map((item) => ({ ...item }));
          this.total = res.count;
        }
      });
    },
    getType() {
      getManagement({
        type: "link",
        curPage: 1,
        pageSize: 9999,
      }).then((res) => {
        // console.log(res);
        this.topData = res.data;
        this.spin = false;
      });
    },
    // 点击类别
    onChange(e) {
      this.curPage = 1;
      this.typeId = e.target.value;
      if (this.typeId == 0) {
        this.typeId = "";
      }
      this.load();
    },
    loadList() {
      this.visibleClass = true;
    },
    handleOkClass() {
      this.$refs.ruleForm_add.validate((valid) => {
        if (valid) {
          let data = {
            title: this.formClass.name,
            type: "link",
          };
          this.postClass(data);
          this.formClass.name = "";
          this.visibleClass = false;
        }
      });
    },
    handleCancelClass() {
      this.visibleClass = false;
    },
    async postClass(data) {
      const response = await AddManagement(data);
      if (response.code === 200) {
        this.$message.success("新增成功！");
        await this.getType();
      } else {
        this.$message.warning(response.message);
      }
    },
    // 点击时间选择框
    timeChange(date, dateString) {
      this.year = dateString;
      this.startTime = dateString[0];
      this.endTime = dateString[1];
    },

    // 点击查询
    search() {
      this.curPage = 1;
      this.load();
    },
    // 点击重置
    clear() {
      this.linkName = "";
      this.startTime = "";
      this.endTime = "";
      this.year = [];
      this.load();
    },
    // 打开移动分组
    moveLink(record) {
      // console.log(record);
      this.visible = true;
      this.category.id = record.id;
      this.categoryId = record.columnId;
    },
    handle(id) {
      this.category.columnId = id;
    },
    handleOk() {
      changeLink({
        id: this.category.id,
        columnId: this.category.columnId,
      }).then((res) => {
        if (res.code === 0) {
          this.$message.success("移动成功");
          this.load();
          this.visible = false;
          this.categoryId = "";
        } else {
          this.$message.warning("移动失败");
          this.categoryId = "";
        }
      });
    },
    handleCancel() {
      this.load();
      this.visible = false;
      this.categoryId = "";
    },
    del(record) {
      delLink(record.id).then((res) => {
        if (res.code === 0) {
          this.$message.success("删除成功");
          this.load();
        } else {
          this.$message.warning("删除失败");
          this.load();
        }
      });
    },
    cancel1() {
      this.$message.warning("取消删除");
      this.load();
    },
    // 改变页码
    PageNOchange(curPage) {
      // console.log(curPage);
      this.curPage = curPage;
      this.load();
    },
    // 表格编辑，变化时
    handleChange(value, id, column) {
      // console.log("表格变化", value, id, column);

      const newData = [...this.link];
      const target = newData.find((item) => id === item.id);
      if (target) {
        target[column] = value;
        // console.log(target[column]);
        this.link = newData;
      }
    },
    // 表格，编辑
    edit(id, record) {
      // console.log(id, record);
      const newData = [...this.link];
      const target = newData.find((item) => id === item.id);
      if (target) {
        target.editable = true;
        //标志图片可编辑，上传时，改为false
        target.imgedit = true;
        this.link = newData;
        // console.log(this.link);
      }
    },
    // 表格，保存
    save(record, id) {
      let flat = false;
      // console.log(record);
      if (record.name == "") {
        flat = true;
        this.$message.warning("请输入名称");
      }

      if (record.imageUrl == "") {
        flat = true;
        this.$message.warning("请上传图片");
      }
      if (flat) {
        return;
      }

      const newData = [...this.link];
      const target = newData.find((item) => id === item.id);
      // 如果是我手动添加的则点击保存时，调用插入接口
      if (target && target.myedit) {
        let a = [];
        a.push({
          name: record.name,
          imageUrl: record.imageUrl,
          link: record.link,
          columnId: parseInt(record.columnId),
        });

        InsertLink(a).then((res) => {
          if (res.code == 0) {
            // 表格数据，
            const newData = [...this.link];
            // 表格的备份数据
            const newCacheData = [...this.cacheData];
            const target = newData.find((item) => id === item.id);
            const targetCache = newCacheData.find((item) => id === item.id);
            if (target && targetCache) {
              delete target.editable;
              this.link = newData;
              Object.assign(targetCache, target);
              this.cacheData = newCacheData;
              this.$message.success("保存成功");
            }
            // 刷新列表
            this.load();
          } else {
            // 表格数据，
            this.cancel(id);
            this.$message.warning("保存失败");
          }
        });
      } else {
        //否则调用修改接口
        changeLink({
          id: id,
          name: record.name,
          imageUrl: record.imageUrl,
          link: record.link,
          columnId: parseInt(record.columnId),
        }).then((res) => {
          if (res.code == 0) {
            // 表格数据，
            const newData = [...this.link];
            // 表格的备份数据
            const newCacheData = [...this.cacheData];
            const target = newData.find((item) => id === item.id);
            const targetCache = newCacheData.find((item) => id === item.id);
            if (target && targetCache) {
              delete target.editable;
              this.link = newData;
              Object.assign(targetCache, target);
              this.cacheData = newCacheData;
              this.$message.success("修改成功");
            }
            // 刷新列表
            this.load();
          } else {
            // 表格数据，
            this.cancel(id);
            this.$message.warning("修改失败");
          }
        });
      }
    },
    // 表格

    cancel(id) {
      const newData = [...this.link];
      const newCacheData = [...this.cacheData];
      const target = newData.find((item) => id === item.id);
      // this.editingKey = '';
      if (target) {
        // 还原改变的数据
        Object.assign(
          target,
          this.cacheData.find((item) => id === item.id)
        );
        // 如果是我手动添加的数据，取消时从列表删除
        if (target.myedit) {
          this.link = newData.filter((item) => {
            return item.id != id;
          });
          this.cacheData = newCacheData.filter((item) => {
            return item.id != id;
          });
          return;
        }
        delete target.editable;
        this.link = newData;
      }
    },

    // 上传封面图
    async materialLibrary(id, column) {
      this.visiblePic = true;
      this.picId = id;
      this.picColumn = column;

      // let inputDOM = this.$refs[`materialLibrary${id}`].files[0];
      // const image = await update(inputDOM);
      // if (image.code === 0) {

        // 修改表格中的imgurl,张灯珍
        // const newData = [...this.link];
        // const target = newData.find((item) => id === item.id);
        // if (target) {
        //   target[column] = image.data.url;
        //   //标志图片可编辑，上传时，改为false
        //   target.imgedit = false;
        //   // console.log(target[column]);
        //   this.link = newData;
        // }

        // this.$set(this.addForm, "imageUrl", image.data.url);
        // console.log("111", this.addForm);
      //   this.$message.success("上传成功");
      // } else {
      //   this.$message.warning(image.message);
      // }
      // document.getElementById([`materialLibrary${id}`]).value = null;
    },
    submit() {
      this.add.push(this.addForm);
      InsertLink(this.add).then((res) => {
        if (res.code == 0) {
          this.load();
          this.$message.success("保存成功");
          this.editForm = {};
          this.visible1 = true;
          this.newAdd = [];
        } else {
          this.$message.warning("保存失败");
          this.addForm = {};
          this.load();
          this.visible = true;
        }
      });
    },
    cancelAdd() {
      this.addForm = {};
      this.load();
    },

    // 表格，重置
    // clearAdd(id) {
    //   const newData = [...this.link];
    //   const target = newData.find((item) => id === item.id);
    //   if (target) {
    //     target.editable = true;
    //     //标志图片可编辑，上传时，改为false
    //     target.imgedit = true;
    //     target.imageUrl = "";
    //     target.link = "";
    //     target.name = "";
    //     (target.columnId = -1), (target.columnName = "");
    //     this.link = newData;
    //     console.log(target);
    //   }
    // },
    clearAdd() {
      this.getType();
    },
    addAgain() {
      // this.addLink();
      this.visible3 = true;
      this.form.name = "";
    },
    // 表格，下拉框
    handleSelectChange(value, id) {
      // console.log(
      //   value.split("&&"),
      //   value.split("&&")[0],
      //   value.split("&&")[1],
      //   id,
      //   "下拉框"
      // );
      const newData = [...this.link];
      const target = newData.find((item) => id === item.id);
      if (target) {
        target["columnId"] = value.split("&&")[0];
        target["columnName"] = value.split("&&")[1];
        // console.log(target["columnId"], target["columnName"]);
        this.link = newData;
      }
    },
    // 添加框
    addLink() {
      // if (this.userInfoList.memberStatus === 0) {
      if (!this.userInfoList.id) {
          this.visibleAlert = true;
      }
      else{

      // console.log("1");
      //表格数据
      let newData = [...this.link];
      //表格数据备份，用于取消编辑时还原数据
      let newCacheData = [...this.link];
      this.addtableCount++;
      newData.unshift({
        columnId: -1,
        columnName: "",
        createdById: "",
        createdByName: "",
        createdTime: "",
        id: this.getCurTime(),
        imageUrl: "",
        link: "",
        name: "",
        imgedit: true, //图片为可编辑状态
        editable: true,
        myedit: true, //用来移除，我的添加
      });
      newCacheData.push({
        columnId: -1,
        columnName: "",
        createdById: "",
        createdByName: "",
        createdTime: "",
        id: this.getCurTime(),
        imageUrl: "",
        link: "",
        name: "",
        imgedit: true, //图片为可编辑状态
        editable: true,
        myedit: true, //用来移除，我的添加
      });
      this.link = newData;
      this.cacheData = newCacheData;
      // console.log(this.link);
      }
    },
    // 获取当前时间
    getCurTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = ("0" + (now.getMonth() + 1)).slice(-2);
      const day = ("0" + now.getDate()).slice(-2);
      const hours = ("0" + now.getHours()).slice(-2);
      const minutes = ("0" + now.getMinutes()).slice(-2);
      const seconds = ("0" + now.getSeconds()).slice(-2);
      const formattedTime = year + month + day + hours + minutes + seconds;
      return formattedTime;
    },

    // add() {
    //   this.visible = true;
    //   this.form.name = "";
    // },
    // 新增确定
    addOk() {
      this.$refs.ruleForm_add.validate(async (valid) => {
        if (valid) {
          let form = {
            title: this.form.name,
            type: "link",
          };
          AddManagement(form).then((res) => {
            if (res.code == 200) {
              this.$message.success("新增成功");
              this.visible3 = false;
              this.form.name = "";
              this.$refs.ruleForm_add.resetFields();
            } else {
              this.$message.warning("新增失败");

              this.$refs.ruleForm_add.resetFields();
            }
          });
        }
      });
    },
    addCancel() {
      this.visible3 = false;
      this.$refs.ruleForm_add.resetFields();
      this.form.name = "";
    },
    closeMainAlert(val) {
      this.visibleAlert = val;
    },
  },
};
</script>

<style scoped lang="scss">
.topTitle {
  color: $topTitleColor;
}
.top {
  width: 100%;
  height: 130px;
  .classTitle {
    width: 100%;
    height: 50%;
    border-bottom: 1px solid #edeff2;
    .title {
      margin-left: 1%;
      display: inline-block;
      padding-top: 20px;
      color: $topTitleColor;
    }
    .content {
      color: $topNameColor;
      margin-left: 5px;
      .iconSheZhi {
        font-size: 20px;
        cursor: pointer;
      }
    }
  }
  .selectTop {
    width: 98%;
    height: 50%;
    margin: auto;
    display: flex;
    justify-content: space-between;
    line-height: 30px;
    margin-top: 15px;
  }
}

.ant-radio-button-wrapper {
  border-radius: 5px;
  border: none;

  &::before {
    display: none; // 隐藏分界线
  }
}

::v-deep .ant-radio-button-wrapper::before {
  display: none;
}

.bottom {
  width: 100%;
  min-height: 580px;
  .title {
    height: 50px;
    line-height: 50px;
    color: $topNameColor;
    font-weight: 600;
    padding-left: 1%;
    border-bottom: 1px solid #edeff2;
  }
}

// .add {
//   width: 98%;
//   margin: auto;
//   height: 40px;
//   margin-top: $LineSpacing;
//   margin-bottom: $LineSpacing;
//   display: block;
//   border-radius: 10px;
//   border: 2px dashed #edeff2;
//   display: flex;
//   cursor: pointer;
//   .addp {
//     display: block;
//     margin: auto;
//   }
// }
.file {
  position: relative;
  display: inline-block;
  background: #1890ff;
  border-radius: 4px;
  padding: 4px 12px;
  overflow: hidden;
  color: white;
  font-size: 15px;
  text-decoration: none;
  text-indent: 0;
  line-height: 20px;
}
.add {
  margin-top: $LineSpacing;
  margin-bottom: $LineSpacing;
  margin-right: 2%;
  float: right;
  display: block;
  z-index: 99;
}

.bgImg {
  border: #dddddd 2px dashed;
  width: 100%;
  height: 50px;
  border-radius: 5px;
  text-align: center;
}

.uploadImg_img {
  position: absolute;
  top: 0;
  width: 100%;
  height: 50px;
}
.moTitle {
  display: flex;
  justify-content: space-between;
  width: 98%;
  margin: auto;
  height: 50px;
  line-height: 50px;
  .font {
    font-weight: 600;
    color: $topNameColor;
  }
}
.topTitle {
  color: $topTitleColor;
}



.ant-spin-nested-loading {
  width: 100%;
  min-height: 280px;
  height: 100%;
}

.ant-table-thead > tr > th {
  font-size: 17px;
  font-weight: 550;
}
.ant-pagination {
  width: 98%;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 10px;
}
.top2 {
  width: $space_div;
  margin: auto;
  height: 60px;
  padding-top: 15px;
}
.liebiao {
  width: 100%;
  border-bottom: 1px solid rgb(238, 233, 233);
  .title {
    color: $topNameColor;
    font-weight: 600;
    height: 50px;
    line-height: 50px;
    width: $space_div;
    margin: auto;
  }
}
</style>
